import * as api from '../../swc-app-api/api'
import * as configuration from '../../swc-app-api/configuration'
import axios from './axios'
import { Cookies, SessionStorage } from 'quasar'

let timeout = null

function flattenNodes(nodes) {
  return nodes.flatMap(node => {
    if (node.children_detail.length === 0) { return node }
    return flattenNodes(node.children_detail)
  })
}

function determineDefaultNode(userInfo, nodes) {
  const flatNodes = flattenNodes(nodes)
  const dataNodes = flatNodes.filter(n => n.is_data)
  const favPage = userInfo.favorite_page
  if (favPage && favPage.includes('/node/')) {
    const nodeId = favPage.replace(/[^0-9]/g, '')
    const node = flatNodes.find(n => n.id === nodeId)
    if (node) { return node }
  }
  if (dataNodes.length > 0) { return dataNodes[0] }
  if (flatNodes.length > 0) { return flatNodes[0] }
  return {}
}

export function setApiClients({commit, state}) {
  const accessToken = localStorage.getItem('auth/ACCESS_TOKEN')
  const config = new configuration.Configuration({accessToken})
  const apiClient = {
    ...api.MasterApiFactory(config, undefined, axios),
    ...api.UserinfoApiFactory(config, undefined, axios),
    ...api.NodesApiFactory(config, undefined, axios),
    ...api.UserApiFactory(config, undefined, axios)
    // ...api.DatasetsApiFactory(config, undefined, axios),
    // ...api.ResampledDatasetsApiFactory(config, undefined, axios),
    // ...api.SitesApiFactory(config, undefined, axios),
  }
  commit('SET_API_CLIENT', apiClient)
}

export function getData({commit, state}) {
  if (!state.apiClient) {
    setApiClients({commit, state})
  }
  const apiClient = state.apiClient

  return new Promise((resolve, reject) => {
    // TODO https://gitlab.com/sjc0611/iot_platform/swc-app/-/issues/9 で実装
    Promise.all([
      apiClient.userinfoRetrieve(), // ユーザー情報
      apiClient.masterOrganizationsList(), // 組織
      apiClient.masterSimpleNodesList(),  // 階層
    ])
      .then((values) => {
        const userInfo = values[0].data
        const nodes = values[2].data
        const organizations = values[1].data

        commit('SET_USERINFO', userInfo)
        // Google analytics(GTM)送信用
        localStorage.setItem('swac_user_id', userInfo.id)
        localStorage.setItem('organization_code', userInfo.organization_code)
        commit('SET_NODES', nodes)
        SessionStorage.set('nodes', JSON.stringify(flattenNodes(nodes)))  // グラフィック関数で使用
        const defualtNode = determineDefaultNode(userInfo, nodes)
        commit('SET_DEFAULT_NODE', defualtNode)
        commit('SET_ORGANIZATIONS', organizations)

        commit('SET_LOADED', true)

        resolve()
      })
      .catch((e) => {
        reject()
        console.error(e)
      })
  })
}

export function destroyData({commit}) {
  commit('SET_USERINFO', {})
  commit('SET_NODES', [])
  commit('SET_ORGANIZATIONS', [])
  commit('SET_LOADED', false)
  commit('SET_DISABLE', false)
}

export function updateFavoritePage({commit, state}, favoritePage) {
  const apiClient = state.apiClient
  const payload = {
    favorite_page: favoritePage
  }
  return new Promise((resolve, reject) => {
    apiClient
      .masterUsersPartialUpdate(state.userInfo.id, payload)
      .then((response) => {
        const {favorite_page} = response.data
        commit('SET_USERINFO', {...state.userInfo, favorite_page})
        resolve()
      })
      .catch((e) => {
        reject()
        console.error(e)
      })
  })
}

export function changeDisable({commit}, isDisable) {
  if(timeout !== null) clearTimeout(timeout)
  timeout = setTimeout(() => {
    commit('SET_DISABLE', false)
    timeout = null
  },1000 * 60);
  commit('SET_DISABLE', isDisable)
}
